<template>
    <div class="vue-iframe-wrapper">
        <template v-if="hasYoutubeVideoId">
            <div v-show="showThumbnail === true">
                <slot></slot>
            </div>

            <youtube :video-id="youtubeVideoId" ref="youtube" @ended="handleEnded"></youtube>

            <button @click="handlePlayClick" :class="showThumbnail ? '' : 'hide'">
                Speel af
            </button>
        </template>
    </div>
</template>

<script>
export default {
    name: "YoutubeWrapper",

    props: ['iframeSrc'],

    data() {
        return {
            showThumbnail: true
        }
    },

    computed: {
        youtubeVideoId() {
            let url = this.iframeSrc.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

            if (!_.isNil(url[2])) {
                return url[2].split(/[^0-9a-z_\-]/i)[0];
            }

            return '';
        },

        hasYoutubeVideoId() {
            return !_.isEmpty(this.youtubeVideoId);
        },

        player() {
            return this.$refs.youtube.player
        }
    },

    methods: {
        handlePlayClick() {
            this.showThumbnail = false;

            this.player.playVideo();
        },

        handleEnded() {
            this.showThumbnail = true;
        }
    }
}
</script>

